import { PropertyStripLayout } from "../../../canvas/properties/PropertyStripLayout";
import { AutoLayoutConfigWidget } from "../../autoLayout/AutoLayoutConfigWidget";
import { frameEditAddonDimensions } from "./FrameAddonDimensionCommands";
import { GridFrameAddon } from "./GridFrameAddon";

export const GridFrameAddonPropertyLayout = PropertyStripLayout<GridFrameAddon>((d, s, o, w, a) => {

    return [
        // Grid Dimensions
        w.createButton({
            text: 'Grid Dimensions',
            image: 'deqo://icons/d2/grid-settings',
            onAction() {
                d(frameEditAddonDimensions, [a.first()?.id]);
            }
        }),
        // Auto Layout
        w.createPopout({
            image: 'deqo://icons/d2/flex',
            text: 'Layout Mode',
            ui: AutoLayoutConfigWidget,
            value: a.get('layoutMode'),
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('layoutMode'));
                    a.set('layoutMode', this.value!);
                });
            }
        }),

    ]
});